/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import CommonTasks from "components/featured-webpage/common-tasks";

const WebpageFeature = (props) => {
    
    const { values, options } = props || {};
    const { type, title, allServices, allServicesPath } = options || {};
    
    return (
        <Fragment>
            {type === "common-tasks" &&
                <CommonTasks
                    values={values}
                    type={type}
                    title={title}
                    allServices={allServices}
                    allServicesPath={allServicesPath}
                />
            }
        </Fragment>
    );
};
export default WebpageFeature;


//                                     <div className="views-row views-row-2 views-row-even">
//
//                                         <div className="views-field views-field-field-link">        <div className="field-content"><a href="node/2786" className="featured-service__link"><span className="featured-service__icon far fa-clipboard-check"></span><span className="featured-service__text">Apply for a permit</span></a></div>  </div>  </div>
//                                     <div className="views-row views-row-3 views-row-odd">
//
//                                         <div className="views-field views-field-field-link">        <div className="field-content"><a href="node/151" className="featured-service__link"><span className="featured-service__icon far fa-trash-alt"></span><span className="featured-service__text">Look up collection day</span></a></div>  </div>  </div>
//                                     <div className="views-row views-row-4 views-row-even">
//
//                                         <div className="views-field views-field-field-link">        <div className="field-content"><a href="node/120" className="featured-service__link"><span className="featured-service__icon far fa-briefcase"></span><span className="featured-service__text">Apply for a job</span></a></div>  </div>  </div>
//                                     <div className="views-row views-row-5 views-row-odd">
//
//                                         <div className="views-field views-field-field-link">        <div className="field-content"><a href="https://app.dnv.org/councilsearchnew/" className="featured-service__link"><span class="featured-service__icon far fa-gavel"></span><span class="featured-service__text">View Council materials</span></a></div>  </div>  </div>
//                                     <div class="views-row views-row-6 views-row-even views-row-last">
//
//                                         <div class="views-field views-field-field-link">        <div class="field-content"><a href="property-development/traffic-impacts-map" class="featured-service__link"><span class="featured-service__icon far fa-traffic-cone"></span><span class="featured-service__text">View the road works map</span></a></div>  </div>  </div>
//                                 </div>
